@if (model$ | async; as model) {
  <div mat-dialog-title>
    <div class="row">
      <div class="col">
        {{ 'DEMAND_REQUEST.DETAIL.PRODUCT_EDIT_DIALOG.TITLE' | translate }}
      </div>
      <div class="col-1 text-end">
        <button mat-icon-button type="button" mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <mat-dialog-content>
    <form [formGroup]="form" #frm="ngForm">
      <formly-form [form]="form" [fields]="fields" [options]="options" [model]="model"></formly-form>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ 'SHARED.CLOSE' | translate }}</button>
    <button (click)="onSaveClicked()" mat-flat-button color="primary">{{ 'SHARED.SAVE' | translate }}</button>
  </mat-dialog-actions>
}
